import React from 'react';
import { FormattedMessage } from 'react-intl';

import { WaitingAlert, DangerAlert, Table } from '@tmapy/style-guide';

import { MainContent } from '../../app/components/MainContent';
import { PageTitle } from '../../app/components/PageTitle';
import { QUERY_STATE } from '../../constants';
import { isHarvestStuck } from '../datasourceHarvest';
import { useDatasourceList } from '../useDatasourceList';

import { DatasourceListItem } from './DatasourceListItem';
import { datasourceMessages as msg } from './datasourceMessages';

export const DatasourceList: React.FC = () => {
  const { queryState, data, fetchedAt, refresh } = useDatasourceList();

  const datasourceList = data?.results ?? [];

  return (
    <MainContent width='fit' scrollRestorationPrefix='datasourcelist'>
      <article className='sg-u-vs-2'>
        <header className='sg-a-d-f sg-a-jc-sb sg-a-ai-b sg-a-cg-2'>
          <PageTitle>
            <FormattedMessage {...msg.datasourceListPageTitle} />
          </PageTitle>
        </header>
        {queryState === QUERY_STATE.WAITING && (
          <WaitingAlert>
            <FormattedMessage {...msg.datasourceListStateWaiting} />
          </WaitingAlert>
        )}
        {queryState === QUERY_STATE.FAIL && (
          <DangerAlert>
            <FormattedMessage {...msg.datasourceListStateFail} />
          </DangerAlert>
        )}
        {datasourceList.length > 0 && (
          <div className='sg-u-box sg-a-px-2 sg-a-pb-2 sg-u-vs-2'>
            <div className='sg-a-mx--2'>
              <Table isClickable>
                <thead>
                  <tr>
                    <th>
                      <FormattedMessage {...msg.name} />
                    </th>
                    <th className='sg-a-ta-r'>
                      <FormattedMessage {...msg.datasetsCount} />
                    </th>
                    <th className='sg-a-ta-r'>
                      <FormattedMessage {...msg.created} />
                    </th>
                    <th className='sg-a-ta-r'>
                      <FormattedMessage {...msg.edited} />
                    </th>
                    <th className='sg-a-ta-r'>
                      <FormattedMessage {...msg.harvested} />
                    </th>
                    <th>
                      <FormattedMessage {...msg.state} />
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {datasourceList.map((datasourceItem) => (
                    <DatasourceListItem
                      key={datasourceItem.url}
                      {...datasourceItem}
                      isStuck={fetchedAt !== null && isHarvestStuck(datasourceItem, fetchedAt)}
                      refresh={refresh}
                    />
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}
      </article>
    </MainContent>
  );
};
